/**
 * Faqja "Me" – i njëjti stil si super admin (dark mode): Raportet, Alarmet, Links, About, Cilësimet, Përdoruesit, Kompanitë, Check-in, LOG OUT.
 */
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

const Me = () => {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'SUPERADMIN';
  const isSuperAdmin = user?.role === 'SUPERADMIN';
  const allowedPaths = user?.allowed_routes && Array.isArray(user.allowed_routes) && user.allowed_routes.length > 0 ? user.allowed_routes : null;
  const canShow = (path) => allowedPaths === null || allowedPaths.includes(path);

  const handleLinks = () => {
    window.open('https://www.dio-iot.com', '_blank', 'noopener,noreferrer');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  /* Shape i njëjtë si Report; ngjyra si kartat e dashboard */
  const cardClass = 'flex items-center gap-3 w-full px-4 py-2.5 rounded-xl bg-white dark:bg-[#1e293b] border border-gray-200 dark:border-[#334155] hover:bg-gray-50 dark:hover:bg-[#2d3a4f] text-left text-gray-800 dark:text-white transition';
  const iconClass = 'w-5 h-5 shrink-0 text-gray-600 dark:text-gray-400';
  const arrow = (
    <svg className="w-5 h-5 shrink-0 text-gray-500 dark:text-gray-400 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  );

  const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ').trim() || user?.username || '–';

  return (
    <Layout>
      <div className="min-h-screen bg-gray-100 dark:bg-[#0f172a] pb-24 md:pb-6">
        <div className="max-w-lg mx-auto px-4 pt-4">
          {/* Header – vetëm emri dhe mbiemri, madhësi e njëjtë si Report */}
          <div className={`${cardClass} mb-3`}>
            <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-[#334155] flex items-center justify-center shrink-0">
              <svg className="w-6 h-6 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div className="min-w-0 flex-1">
              <p className="font-medium text-gray-900 dark:text-white truncate">{fullName}</p>
            </div>
            {arrow}
          </div>

          {/* Lista – Report, Alarmet, Check-in, Users, Companies, Links, About, System Settings (respektohet allowed_routes) */}
          <div className="space-y-2">
            {canShow('/reports') && (
            <Link to="/reports" className={cardClass}>
              <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span>{t('reports')}</span>
              {arrow}
            </Link>
            )}
            {canShow('/alarms') && (
            <Link to="/alarms" className={cardClass}>
              <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              <span>{t('alarms')}</span>
              {arrow}
            </Link>
            )}
            {canShow('/checkin') && (
            <Link to="/checkin" className={cardClass}>
              <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>{t('checkin')}</span>
              {arrow}
            </Link>
            )}

            {isAdmin && canShow('/users') && (
              <Link to="/users" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
                <span>{t('users')}</span>
                {arrow}
              </Link>
            )}

            {isSuperAdmin && canShow('/companies') && (
              <Link to="/companies" className={cardClass}>
                <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <span>{t('companies')}</span>
                {arrow}
              </Link>
            )}

            <button type="button" onClick={handleLinks} className={cardClass}>
              <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.172-1.172a4 4 0 001.172-2.828z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              <span>{t('links')}</span>
              {arrow}
            </button>

            <div className={cardClass + ' cursor-default'} style={{ pointerEvents: 'none' }}>
              <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{t('about')}</span>
              <span className="ml-auto text-sm text-gray-600 dark:text-gray-400">1.02</span>
            </div>

            {canShow('/me/notifications') && (
            <Link to="/me/notifications" className={cardClass}>
              <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
              <span>{t('notification')}</span>
              {arrow}
            </Link>
            )}

            <Link to="/me/settings" className={cardClass}>
              <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>{t('systemSettings')}</span>
              {arrow}
            </Link>
          </div>

          {/* LOG OUT – shape i ngushtuar, ngjyrë si dashboard */}
          <button
            type="button"
            onClick={handleLogout}
            className="w-full mt-5 py-2.5 rounded-xl font-medium transition bg-white dark:bg-[#1e293b] border border-gray-200 dark:border-[#334155] hover:bg-gray-50 dark:hover:bg-[#2d3a4f] text-red-600 dark:text-red-400"
          >
            {t('logout').toUpperCase()}
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default Me;
